export default "__VITE_ASSET__D4r$HhMS__"